/**
 * **Focus back on the control a session overlay was opened from, once the overlay has closed.**
 *
 * It cannot happen in the close handler: everything behind the overlay's scrim is `inert` while it
 * is open, and an inert element REFUSES focus. So the opener is found after the commit that removed
 * the overlay and un-inerted the page, which is what this effect is. The opener is found by its
 * `data-session-opener` stamp (`sessionOpenerKey`) rather than held as a ref, because on the client
 * detail what survives a close is the URL's session and intent, not an element.
 *
 * Three hosts: the client detail (the overlay in its URL), `/zadania` and the Pulpit (owner, 25
 * September 2026: „Zobacz sesję" opens the panel in place on every screen).
 */

import { useEffect, useRef } from 'react';

export function useSessionOpenerReturn(openerKey: string | null): void {
  const lastOpenerKey = useRef<string | null>(openerKey);
  useEffect(() => {
    const closed = lastOpenerKey.current;
    lastOpenerKey.current = openerKey;
    if (openerKey !== null || closed === null) return;
    document.querySelector<HTMLElement>(`[data-session-opener="${closed}"]`)?.focus();
  }, [openerKey]);
}
